import { Button, Heading, Input, InputGroup, InputLeftAddon, SimpleGrid, Switch } from "@chakra-ui/react"
import { Fragment, useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import Select from 'react-select';
import { formatSimpelDate, RegExEmail } from "../../../util/util";
import { obtenerPostventasActivos } from "../../../services/Admin/obtenerPostventasActivos";
import obtenerTitulares from "../../../services/obtenerTitulares";
import UserContext from "../../../context/userContext";
import obtenerTitular from "../../../services/obtenerTitular";
import { deleteTitular, editarTitular } from "../../../services/editarTitular";
import InfoModal from "../../util/confirmModal/InfoModal";
import ConfirmModal from "../../util/confirmModal/confirmModal";
import { useTranslation } from "react-i18next";
import { Loading } from "../../Common/Loading";



const NuevoEditarTitular = () => {

    const { t } = useTranslation();

    const { titularId } = useParams();
    const { user } = useContext(UserContext);

    const navigate = useNavigate();
    // USER DATA

    const [nombre, setNombre] = useState("");
    const [apellidos, setApellidos] = useState("");
    const [email, setEmail] = useState("");
    const [contrasena, setContrasena] = useState("puta");
    const [fechaNacimiento, setFechaNacimiento] = useState("");
    const [esCotitular, setEsCotitular] = useState({ value: false, label: 'Titular' });
    const [precioMembresia, setPrecioMembresia] = useState(0);
    const [genero, setGenero] = useState(null);
    const [fechaFirmaContrato, setFechaFirmaContrato] = useState("");
    const [ocupacion, setOcupacion] = useState("");
    const [tipoCabana, setTipoCabana] = useState(null);
    const [telefono, setTelefono] = useState("");
    const [agentePostVenta, setAgentePostVenta] = useState(null);
    const [nochesBaja, setNochesBaja] = useState("0");
    const [nochesAlta, setNochesAlta] = useState("0");
    const [numeroMembresia, setNumeroMembresia] = useState("");
    const [idCoTitular, setIdCoTitular] = useState(null);
    const [fueReferido, setFueReferido] = useState(false);
    const [idReferido, setIdReferido] = useState(null);
    const [banco, setBanco] = useState("");
    const [clabe, setClabe] = useState("");
    const [nombreTarjeta, setNombreTarjeta] = useState("");

    const [loading, setLoading] = useState(false)

    // USER DATA END

    // SELECT OPTIONS
    const [tipoMembresiaOptions, setTipoMembresiaOptions] = useState([
        { value: false, label: t('HOLDER') },
        { value: true, label: t('CO_HOLDER') },
      ]);
    const generoOptions = [
        { value: 'Masculino', label: t('MASCULINE') },
        { value: 'Femenino', label: t('FEMENINE') },
    ]
    const tipoCabanaOptions = [
        { value: '', label: t('SELECT_CABIN') },
        { value: 'BAMBU', label: t('BAMBU') },
        { value: 'PIRUL', label: t('PIRUL') },
        { value: 'MEZQUITE', label: t('MEZQUITE') },
      ];
    const [agentePostVentaOptions, setAgentePostVentaOptions] = useState([]);
    const [titularOptions, setTitularOptions] = useState([]);
    const [referidoOptions, setReferidoOptions] = useState([]);

    const [agentePostVentaLoaded, setAgentePostVentaLoaded] = useState(false);
    const [titularLoaded, setTitularLoaded] = useState(false);
    const [referidoLoaded, setReferidoLoaded] = useState(false);

    // SELECT OPTIONS END
    
    // USER DATA INDIVIDUAL ERRORS

    const [nombreError, setNombreError] = useState(null);
    const [apellidosError, setApellidosError] = useState(null);
    const [emailError, setEmailError] = useState(null);
    const [contrasenaError, setContrasenaError] = useState(null);
    const [fechaNacimientoError, setFechaNacimientoError] = useState(null);
    const [generoError, setGeneroError] = useState(null);
    const [precioMembresiaError, setPrecioMembresiaError] = useState(null);
    const [fechaFirmaContratoError, setFechaFirmaContratoError] = useState(null);
    const [ocupacionError, setOcupacionError] = useState(null);
    const [tipoCabanaError, setTipoCabanaError] = useState(null);
    const [telefonoError, setTelefonoError] = useState(null);
    const [agentePostVentaError, setAgentePostVentaError] = useState(null);
    const [nochesBajaError, setNochesBajaError] = useState(null);
    const [nochesAltaError, setNochesAltaError] = useState(null);
    const [numeroMembresiaError, setNumeroMembresiaError] = useState(null);
    const [idCoTitularError, setIdCoTitularError] = useState(null);
    const [idReferidoError, setIdReferidoError] = useState(null);
    const [bancoError, setBancoError] = useState(null);
    const [clabeError, setClabeError] = useState(null);
    const [nombreTarjetaError, setNombreTarjetaError] = useState(null);

    // USER DATA INDIVIDUAL ERRORS END

    const modalInfoDefault = {
        infoTitle: '',
        infoMessage: '',
        infoIsOpen: false,
        infoIsError: false,
        infoCallback: null
    }

    const [
        {
            infoTitle,
            infoMessage,
            infoIsOpen,
            infoIsError,
            infoCallback
        },
        setInfoModal
    ] = useState(modalInfoDefault)

    const modalConfirmDefault = {
        confirmTitle: '',
        confirmMessage: '',
        idToDelete: null,
        confirmIsOpen: false,
    }


    const [
        {
            confirmTitle,
            confirmMessage,
            idToDelete,
            confirmIsOpen,
        },
        setConfirmModal
    ] = useState(modalConfirmDefault)

    const [saving, setSaving] = useState(false)
    const [deleting, setDeleting] = useState(false)
    const [titulares, setTitulares] = useState(null)

    // INPUT VALIDATION

    const checkInput = {
        nombre: async () => {
            if (nombre === "") {
                setNombreError(t("ERROR_NAME_REQUIRED"));
                return false;
            } else {
                setNombreError(null);
                return true;
            }
        },
        apellidos: async () => {
            if (apellidos === "") {
                setApellidosError(t("ERROR_LAST_NAME_REQUIRED"));
                return false;
            } else {
                setApellidosError(null);
                return true;
            }
        },
        email: async () => {
            if (email === "") {
                setEmailError(t("ERROR_EMAIL_REQUIRED"));
                return false;
            } else if (!RegExEmail.test(email)) {
                setEmailError(t("ERROR_EMAIL_INVALID"));
                return false;
            }
            else {
                setEmailError(null);
                return true;
            }
        },
        contrasena: async () => {
            if (contrasena === "") {
                setContrasenaError(null);
                return true;
            } if (contrasena.length > 10) {
                setContrasenaError(t("ERROR_PASSWORD_TOO_LONG"));
                return false;
            } else {
                setContrasenaError(null);
                return true;
            }
        },
        genero: async () => {
            if (genero === null) {
                setGeneroError(t("ERROR_GENDER_REQUIRED"));
                return false;
            } else {
                setGeneroError(null);
                return true;
            }
        },
        fechaFirmaContrato: async () => {
            if (fechaFirmaContrato === "" || fechaFirmaContrato === null) {
                setFechaFirmaContratoError(t("ERROR_CONTRACT_DATE_REQUIRED"));
                return false;
            } else {
                setFechaFirmaContratoError(null);
                return true;
            }
        },
        precioMembresia: async () => {
            if (precioMembresia === "" || precioMembresia === 0) {
                setPrecioMembresiaError(t("ERROR_MEMBERSHIP_PRICE_REQUIRED"));
                return false;
            } else if (isNaN(precioMembresia) || precioMembresia < 0) {
                setPrecioMembresiaError(t("ERROR_MEMBERSHIP_PRICE_INVALID"));
                return false;
            } else {
                setPrecioMembresiaError(null);
                return true;
            }
        },
        tipoCabana: async () => {
            if (tipoCabana === null) {
                setTipoCabanaError(t("ERROR_CABIN_TYPE_REQUIRED"));
                return false;
            } else {
                setTipoCabanaError(null);
                return true;
            }
        },
        telefono: async () => {
            if (telefono === "") {
                setTelefonoError(t("ERROR_PHONE_REQUIRED"));
                return false;
            } else if (telefono.length < 10) {
                setTelefonoError(t("ERROR_PHONE_INVALID"));
                return false;
            } else {
                setTelefonoError(null);
                return true;
            }
        },
        agentePostVenta: async () => {
            if (agentePostVenta === null) {
                setAgentePostVentaError(t("ERROR_POST_SALE_AGENT_REQUIRED"));
                return false;
            } else {
                setAgentePostVentaError(null);
                return true;
            }
        },
        nochesBaja: async () => {
            if(isNaN(nochesBaja)){
                setNochesBajaError(t("ERROR_LOW_SEASON_NIGHTS_INVALID"));
                return false;
            }
            if (nochesBaja < 0) {
                setNochesBajaError(t("ERROR_LOW_SEASON_NIGHTS_NEGATIVE"));
                return false;
            }
            setNochesBajaError(null);
            return true;
        },
        nochesAlta: async () => {
            if(isNaN(nochesAlta)){
                setNochesAltaError(t("ERROR_HIGH_SEASON_NIGHTS_INVALID"));
                return false;
            }
            if (nochesAlta < 0) {
                setNochesAltaError(t("ERROR_HIGH_SEASON_NIGHTS_NEGATIVE"));
                return false;
            }
            setNochesAltaError(null);
            return true;
        },
        numeroMembresia: async () => {
            if (numeroMembresia === "") {
                setNumeroMembresiaError(t("ERROR_MEMBERSHIP_NUMBER_REQUIRED"));
                return false;
            } else {
                setNumeroMembresiaError(null);
                return true;
            }
        },
        idCoTitular: async () => {
            if (esCotitular.value === true && idCoTitular === null) {
                setIdCoTitularError(t("ERROR_CO_HOLDER_REQUIRED"));
                return false;
            } else {
                setIdCoTitularError(null);
                return true;
            }
        },
        idReferido: async () => {
            if (fueReferido === true && idReferido === null) {
                setIdReferidoError(t("ERROR_REFERRED_REQUIRED"));
                return false;
            } else {
                setIdReferidoError(null);
                return true;
            }
        },
        banco: async () => {
            if (esCotitular.value === true) {
                setBancoError(null);
                return true;
            }
            if (banco === "") {
                setBancoError(t("ERROR_BANK_REQUIRED"));
                return false;
            } else {
                setBancoError(null);
                return true;
            }
        },
        clabe: async () => {
            if (esCotitular.value === true) {
                setBancoError(null);
                return true;
            }
            if (clabe === "") {
                setClabeError(t("ERROR_CLABE_REQUIRED"));
                return false;
            } else if (clabe.length < 18) {
                setClabeError(t("ERROR_CLABE_INVALID"));
                return false;
            } else {
                setClabeError(null);
                return true;
            }
        },
        nombreTarjeta: async () => {
            if (esCotitular.value === true) {
                setBancoError(null);
                return true;
            }
            if (nombreTarjeta === "") {
                setNombreTarjetaError(t("ERROR_CARDHOLDER_NAME_REQUIRED"));
                return false;
            } else {
                setNombreTarjetaError(null);
                return true;
            }
        },
        checkAll: async (skip=[]) =>{
            let result = true
            for(const key in checkInput){
                if(key === "checkAll" || skip.findIndex(itm => itm === key) !== -1){
                    continue
                }
                const response = await checkInput[key]()
                if(result && !response){
                    result = false
                }
            }
            return result
        }
    }

    // INPUT VALIDATION END

    const requestPostVenta = async () => {
        try{
            const response = await obtenerPostventasActivos(user.id)
            if(response.status === 200){
                const data = response.data;
                const options = data.postVentas.map((item) => ({
                    value: item.id,
                    label: `${item.nombre ? item.nombre : ''} ${item.apellidos ? item.apellidos : ''} ${item.numero ? item.numero : ''}`,
                }));
                setAgentePostVentaOptions(options)
                setAgentePostVentaLoaded(true)
            }else{
                console.error("Error al obtener los post-venta")
            }
        }catch(err){
            console.error(err)
        }
    }

    const requestTitulares = async () => {
        try {
            const response = await obtenerTitulares(user.id, 1)
            if (response.status === 200) {
                const data = response.data;
                setTitulares(data.titulares)
                const options = data.titulares.map((item) => ({
                    value: item.id,
                    label: `${item.membresia} NOMBRE: ${item.nombre} ${item.apellidos}`,
                }));
                setTitularOptions(options)
                setTitularLoaded(true)
            } else {
                console.error("Error al obtener los titulares")
            }
        } catch (err) {
            console.error(err)
        }
    }

    const requestReferidos = async () => {
        try {
            const response = await obtenerTitulares(user.id, 0, 1)
            if (response.status === 200) {
                const data = response.data
                const options = data.titulares.map((item) => ({
                    value: item.id,
                    label: `${item.membresia} NOMBRE: ${item.nombre} ${item.apellidos}`,
                    fechaFirma: item.fechaFirma
                }));
                setReferidoOptions(options)
                setReferidoLoaded(true)
            } else {
                console.error("Error al obtener los referidos")
            }
        } catch (err) {
            console.error(err)
        }
    }

    const requestTitular = async () => {
        setLoading(true)
        try{
            const response = await obtenerTitular(titularId)
            const data = response.data.titular;
            setNombre(data.nombre ? data.nombre : "")
            setApellidos(data.apellidos ? data.apellidos : "")
            setEmail(data.correo ? data.correo : "")
            setContrasena(data.contrasena ? data.contrasena : "")
            setFechaNacimiento((data.fechaNacimiento ? await formatSimpelDate(new Date(data.fechaNacimiento)) : null))
            setEsCotitular({ value: data.coTitular, label: data.coTitular ? 'Co-Titular' : 'Titular' })
            setGenero({ value: data.genero, label: data.genero })
            setFechaFirmaContrato(data.fechaFirma ? await formatSimpelDate(new Date(data.fechaFirma)) : null)
            setOcupacion(data.ocupacion ? data.ocupacion : "")
            setPrecioMembresia(data.precioCompraMembresia ? data.precioCompraMembresia : 0)
            setTipoCabana(tipoCabanaOptions.find((option) => option.value === data.tipoCabana))
            setTelefono(data.numeroTel ? data.numeroTel : "")
            setAgentePostVenta(agentePostVentaOptions.find((option) => option.value === data.postVentaId))
            setNochesBaja(data.numeroNoches ? data.numeroNoches : "0")
            setNochesAlta(data.nochesAlta ? data.nochesAlta : "0")
            setNumeroMembresia(data.membresia ? removePrefix(data.membresia) : "")
            setIdCoTitular(data.idCoTitular ? titularOptions.find((option) => option.value === data.idCoTitular) : null)
            setFueReferido(data.referido !== null)
            setIdReferido(data.referido ? referidoOptions.find((option) => option.value === data.referido.titularId) : null)
            setBanco(data.cuentaBancaria && data.cuentaBancaria.banco ? data.cuentaBancaria.banco : "")
            setClabe(data.cuentaBancaria && data.cuentaBancaria.clabe ? data.cuentaBancaria.clabe : "")
            setNombreTarjeta(data.cuentaBancaria && data.cuentaBancaria.nombre ? data.cuentaBancaria.nombre : "")
        } catch(err){
            console.error(err)
        }finally{
            setLoading(false)
        }
    }
    
    const removePrefix = (str) => {
        const prefix = "LCGC";
        if (str.startsWith(prefix)) {
            return str.slice(prefix.length + 1);
        }
        return str;
    }


    const requestUpdateTitular = async () => {
        const check = await checkInput.checkAll()
        if(!check){
            console.error("Error en los campos")
            return
        }

        let data = {
            titularId,
            nombre,
            apellidos,
            correo: email,
            contrasena: contrasena ? contrasena : null,
            fechaNacimiento,
            genero: genero.value,
            precioCompraMembresia: parseFloat(precioMembresia),
            fechaFirmaContrato,
            ocupacion,
            tipoCabana: tipoCabana.value,
            telefono,
            idCoTitular: esCotitular.value ? idCoTitular.value : null,
            idReferido: fueReferido ? idReferido.value : null,
            postVentaId: agentePostVenta.value,
            nochesBaja: parseInt(nochesBaja),
            nochesAlta: parseInt(nochesAlta),
            membresia: numeroMembresia,
            currentDate: new Date().toISOString()
        }

        if(!esCotitular.value){
            const bancoData = {
                banco,
                clabe,
                nombreTarjeta,
            }
            data = {
                ...data,
                ...bancoData
            }
        }

        setSaving(true)
        try{
            const response = await editarTitular(data)
            requestTitular()
            setInfoModal({
                infoTitle: t("HOLDER_UPDATED"),
                infoMessage: t("HOLDER_UPDATED_SUCCESS"),
                infoIsOpen: true,
                infoIsError: false,
            })
        }catch(err){
            console.log(err)
            const message = err.response.data ? err.response.data.msg : t("HOLDER_UPDATE_ERROR_MESSAGE");
            setInfoModal({
                infoTitle: t("HOLDER_UPDATE_ERROR"),
                infoMessage: message,
                infoIsOpen: true,
                infoIsError: true,
            })
        } finally{
            setSaving(false)
        }
    }

    const requestDeleteTitular = async () => {
        setDeleting(true)
        try{
            const response = await deleteTitular(titularId)
            setConfirmModal(modalConfirmDefault)
            setInfoModal({
                infoTitle: t("HOLDER_DELETED"),
                infoMessage: t("HOLDER_DELETED_SUCCESS"),
                infoIsOpen: true,
                infoIsError: false,
                infoCallback: () => {
                    navigate("/titular")
                }
            })
        }catch(err){
            console.log(err)
            const message = err.response.data ? err.response.data.msg : t("HOLDER_DELETE_ERROR_MESSAGE");
            setInfoModal({
                infoTitle: t("HOLDER_DELETE_ERROR"),
                infoMessage: message,
                infoIsOpen: true,
                infoIsError: true,
            });
        }
        finally{
            setDeleting(false)
        }
    }

    useEffect(() => {
        requestPostVenta()
        requestTitulares()
        requestReferidos()
    }, [])

    useEffect(() => {
        if (agentePostVentaLoaded && titularLoaded && referidoLoaded) {
            requestTitular()
        }
    }, [agentePostVentaLoaded, titularLoaded, referidoLoaded])

    const getInitialLetter = (value) => {
    if (value) {
        return value.charAt(0).toUpperCase();
    }
        return '';
    }

    return(
        <div className="pxcontainer">
            {
                loading ? (
                    <Loading/>
                )
                :
                (
                    <div className="px-3 py-2">
                        <Heading as="h2" size="lg">
                            {t("EDIT_HOLDER")}
                        </Heading>
                        <SimpleGrid columns={2} spacingY={2} spacingX={5} mt={5}>
                            <div className="form-group"> 
                                <label htmlFor="nombre">{t("NAME")}</label>
                                <input 
                                    type="text" 
                                    className="form-control" 
                                    id="nombre" 
                                    value={nombre} 
                                    onChange={(e) => setNombre(e.target.value)} 
                                    onBlur={checkInput.nombre}
                                    placeholder={t("NAME")}
                                    style={{ borderColor: nombreError ? 'red' : '' }}
                                    disabled={saving}
                                />
                                {nombreError && <span className="text-danger">{nombreError}</span>}
                            </div>
                            <div className="form-group">
                                <label htmlFor="apellidos">{t("LAST_NAME")}</label>
                                <input 
                                    type="text" 
                                    className="form-control" 
                                    id="apellidos" 
                                    value={apellidos} 
                                    onChange={(e) => setApellidos(e.target.value)} 
                                    onBlur={checkInput.apellidos}
                                    placeholder={t("LAST_NAME")}
                                    style={{ borderColor: apellidosError ? 'red' : '' }}
                                    disabled={saving}
                                />
                                {apellidosError && <span className="text-danger">{apellidosError}</span>}
                            </div>
                            <div className="form-group">
                                <label htmlFor="email">{t("EMAIL")}</label>
                                <input 
                                    type="email" 
                                    className="form-control" 
                                    id="email" 
                                    value={email} 
                                    onChange={(e) => setEmail(e.target.value)} 
                                    onBlur={checkInput.email}
                                    placeholder={t("EMAIL")}
                                    style={{ borderColor: emailError ? 'red' : '' }}
                                    disabled={saving}
                                />
                                {emailError && <span className="text-danger">{emailError}</span>}
                            </div>
                            <div className="form-group">
                                <label htmlFor="contrasena">{t("PASSWORD")}</label>
                                <input 
                                    type="password" 
                                    className="form-control" 
                                    id="contrasena" 
                                    value={contrasena} 
                                    onChange={(e) => setContrasena(e.target.value)} 
                                    onBlur={checkInput.contrasena}
                                    placeholder={t("PASSWORD")}
                                    style={{ borderColor: contrasenaError ? 'red' : '' }}
                                    disabled={saving}
                                />
                                {contrasenaError && <span className="text-danger">{contrasenaError}</span>}
                            </div>
                            <div className="form-group">
                                <label htmlFor="tipoCabana">{t("CABIN_TYPE")}</label>
                                <Select 
                                    id="tipoCabana" 
                                    options={tipoCabanaOptions} 
                                    value={tipoCabana} 
                                    onChange={(e) => setTipoCabana(e)} 
                                    onMenuClose={checkInput.tipoCabana}
                                    styles={{ control: (base) => ({ ...base, borderColor: tipoCabanaError ? 'red' : base.borderColor }) }}
                                    disabled={saving}
                                />
                                {tipoCabanaError && <span className="text-danger">{tipoCabanaError}</span>}
                            </div>
                            <div className='container-input'>
                                <label id='membresia' style={{fontWeight: 'bold'}}>{t('MEMBERSHIP')}</label>
                                <InputGroup>
                                    <InputLeftAddon>{`LCGC${
                                        esCotitular.value ?
                                        (idCoTitular && titulares ? getInitialLetter(titulares.find(t => t.value === idCoTitular).text) : '-') :
                                        (tipoCabana ? getInitialLetter(tipoCabana.value) : '-')}`
                                    }</InputLeftAddon>
                                    <Input
                                        id='membresia'
                                        className='pxFormContainer'
                                        type="text"
                                        name="membresia"
                                        value={numeroMembresia}
                                        onChange={(e => setNumeroMembresia(e.target.value))}
                                        error={checkInput.numeroMembresia}
                                        disabled={saving}
                                        required
                                    />
                                </InputGroup>
                            </div>
                            <div className="form-group">
                                <label htmlFor="tipoMembresia">{t("MEMBERSHIP_TYPE")}</label>
                                <Select
                                    id="tipoMembresia"
                                    options={tipoMembresiaOptions}
                                    value={esCotitular}
                                    onChange={(e) => setEsCotitular(e)}
                                    onMenuClose={checkInput.idCoTitular}
                                    disabled={saving}
                                />
                            </div>
                            <div className="container-input">
                                <label id='precioMembresia' style={{fontWeight: 'bold'}}>{t('MEMBERSHIP_PRICE')}</label>
                                <InputGroup>
                                    <InputLeftAddon>$</InputLeftAddon>
                                    <Input
                                        id='precioMembresia'
                                        className='pxFormContainer'
                                        type="number"
                                        name="precioMembresia"
                                        value={precioMembresia}
                                        onChange={(e => setPrecioMembresia(e.target.value))}
                                        onBlur={checkInput.precioMembresia}
                                        error={checkInput.precioMembresia}
                                        disabled={saving}
                                        required
                                    />
                                </InputGroup>
                                { precioMembresiaError && <span className="text-danger">{precioMembresiaError}</span>}
                            </div>
                            {
                                esCotitular.value && (
                                    <div className="form-group">
                                        <label htmlFor="idCoTitular">{t("CO_HOLDER_ID")}</label>
                                        <Select
                                            id="idCoTitular"
                                            options={titularOptions}
                                            value={idCoTitular}
                                            onChange={(e) => setIdCoTitular(e)}
                                            onMenuClose ={checkInput.idCoTitular}
                                            styles={{ control: (base) => ({ ...base, borderColor: idCoTitularError ? 'red' : base.borderColor }) }}
                                            disabled={saving}
                                        />
                                        {idCoTitularError && <span className="text-danger">{idCoTitularError}</span>}
                                    </div>
                                )
                            }
                            <div className="form-group">
                                <label htmlFor="genero">{t("GENDER")}</label>
                                <Select 
                                    id="genero" 
                                    options={generoOptions} 
                                    value={genero} 
                                    onChange={(e) => setGenero(e)} 
                                    onMenuClose={checkInput.genero}
                                    styles={{ control: (base) => ({ ...base, borderColor: generoError ? 'red' : base.borderColor }) }}
                                    disabled={saving}
                                />
                                {generoError && <span className="text-danger">{generoError}</span>}
                            </div>
                            <div className="form-group">
                                <label htmlFor="fechaFirmaContrato">{t("CONTRACT_SIGN_DATE")}</label>
                                <input 
                                    type="date" 
                                    className="form-control" 
                                    id="fechaFirmaContrato" 
                                    value={fechaFirmaContrato} 
                                    onChange={(e) => setFechaFirmaContrato(e.target.value)} 
                                    onBlur={checkInput.fechaFirmaContrato}
                                    placeholder={t("CONTRACT_SIGN_DATE")}
                                    style={{ borderColor: fechaFirmaContratoError ? 'red' : '' }}
                                    disabled={saving}
                                />
                                {fechaFirmaContratoError && <span className="text-danger">{fechaFirmaContratoError}</span>}
                            </div>
                            <div className="form-group">
                                <label htmlFor="ocupacion">{t("OCCUPATION")}</label>
                                <input 
                                    type="text" 
                                    className="form-control" 
                                    id="ocupacion" 
                                    value={ocupacion} 
                                    onChange={(e) => setOcupacion(e.target.value)} 
                                    placeholder={t("OCCUPATION")}
                                    style={{ borderColor: ocupacionError ? 'red' : '' }}
                                    disabled={saving}
                                />
                                {ocupacionError && <span className="text-danger">{ocupacionError}</span>}
                            </div>
                            <div className="form-group">
                                <label htmlFor="fechaNacimiento">{t("BIRTH_DATE")}</label>
                                <input 
                                    type="date" 
                                    className="form-control" 
                                    id="fechaNacimiento" 
                                    value={fechaNacimiento} 
                                    onChange={(e) => setFechaNacimiento(e.target.value)} 
                                    placeholder={t("BIRTH_DATE")}
                                    style={{ borderColor: fechaNacimientoError ? 'red' : '' }}
                                    disabled={saving}
                                />
                                {fechaNacimientoError && <span className="text-danger">{fechaNacimientoError}</span>}
                            </div>
                            <div className="form-group">
                                <label htmlFor="telefono">{t("PHONE")}</label>
                                <input 
                                    type="text" 
                                    className="form-control" 
                                    id="telefono" 
                                    value={telefono} 
                                    onChange={(e) => setTelefono(e.target.value)} 
                                    onBlur={checkInput.telefono}
                                    placeholder={t("PHONE")}
                                    style={{ borderColor: telefonoError ? 'red' : '' }}
                                    disabled={saving}
                                />
                                {telefonoError && <span className="text-danger">{telefonoError}</span>}
                            </div>
                            <div className="form-group">
                                <label htmlFor="agentePostVenta">{t("POST_SALE_AGENT")}</label>
                                <Select 
                                    id="agentePostVenta" 
                                    options={agentePostVentaOptions} 
                                    value={agentePostVenta} 
                                    onChange={(e) => setAgentePostVenta(e)} 
                                    onMenuClose={checkInput.agentePostVenta}
                                    styles={{ control: (base) => ({ ...base, borderColor: agentePostVentaError ? 'red' : base.borderColor }) }}
                                    isClearable={true}
                                    disabled={saving}
                                />
                                {agentePostVentaError && <span className="text-danger">{agentePostVentaError}</span>}
                            </div>
                            <div className="form-group">
                                <label htmlFor="nochesBaja">{t("LOW_SEASON_NIGHTS")}</label>
                                <input 
                                    type="text" 
                                    className="form-control" 
                                    id="nochesBaja" 
                                    onChange={(e) => setNochesBaja(e.target.value)} 
                                    value={nochesBaja} 
                                    onBlur={checkInput.nochesBaja}
                                    placeholder={t("LOW_SEASON_NIGHTS")}
                                    style={{ borderColor: nochesBajaError ? 'red' : '' }}
                                    disabled={saving}
                                />
                                {nochesBajaError && <span className="text-danger">{nochesBajaError}</span>}
                            </div>
                            <div className="form-group">
                                <label htmlFor="nochesAlta">{t("HIGH_SEASON_NIGHTS")}</label>
                                <input 
                                    type="text" 
                                    className="form-control" 
                                    id="nochesAlta" 
                                    value={nochesAlta} 
                                    onChange={(e) => setNochesAlta(e.target.value)} 
                                    onBlur={checkInput.nochesAlta}
                                    placeholder={t("HIGH_SEASON_NIGHTS")}
                                    style={{ borderColor: nochesAltaError ? 'red' : '' }}
                                    disabled={saving}
                                />
                                {nochesAltaError && <span className="text-danger">{nochesAltaError}</span>}
                            </div>
                            {/* <div className="form-group">
                                <label htmlFor="numeroMembresia">{t("MEMBERSHIP_NUMBER")}</label>
                                <input 
                                    type="text" 
                                    className="form-control" 
                                    id="numeroMembresia" 
                                    value={numeroMembresia} 
                                    onChange={(e) => setNumeroMembresia(e.target.value)} 
                                    onBlur={checkInput.numeroMembresia}
                                    placeholder={t("MEMBERSHIP_NUMBER")}
                                    style={{ borderColor: numeroMembresiaError ? 'red' : '' }}
                                />
                                {numeroMembresiaError && <span className="text-danger">{numeroMembresiaError}</span>}
                            </div> */}
                            <div className="form-group">
                                <label htmlFor="fueReferido">{t("REFERRED")}</label>
                                <Switch 
                                    id="fueReferido" 
                                    isChecked={fueReferido} 
                                    onChange={(e) => setFueReferido(e.target.checked)}
                                    disabled={saving}
                                />
                            </div>
                            {
                                fueReferido && (
                                    <div className="form-group">
                                        <label htmlFor="idReferido">{t("REFERRED_ID")}</label>
                                        <Select
                                            id="idReferido"
                                            options={referidoOptions}
                                            value={idReferido}
                                            onChange={(e) => setIdReferido(e)}
                                            onMenuClose={checkInput.idReferido}
                                            styles={{ control: (base) => ({ ...base, borderColor: idReferidoError ? 'red' : base.borderColor }) }}
                                            disabled={saving}
                                        />

                                        {idReferidoError && <span className="text-danger">{idReferidoError}</span>}
                                    </div>
                                )
                            }
                            {
                                !esCotitular.value && (
                                    <Fragment>
                                        <div className="form-group">
                                            <label htmlFor="banco">{t("BANK")}</label>
                                            <input 
                                                type="text" 
                                                className="form-control" 
                                                id="banco" 
                                                value={banco} 
                                                onChange={(e) => setBanco(e.target.value)} 
                                                onBlur={checkInput.banco}
                                                placeholder={t("BANK")}
                                                style={{ borderColor: bancoError ? 'red' : '' }}
                                                disabled={saving}
                                            />
                                            {bancoError && <span className="text-danger">{bancoError}</span>}
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="clabe">{t("CLABE")}</label>
                                            <input 
                                                type="text" 
                                                className="form-control" 
                                                id="clabe" 
                                                value={clabe} 
                                                onChange={(e) => setClabe(e.target.value)} 
                                                onBlur={checkInput.clabe}
                                                placeholder={t("CLABE")}
                                                style={{ borderColor: clabeError ? 'red' : '' }}
                                                disabled={saving}
                                            />
                                            {clabeError && <span className="text-danger">{clabeError}</span>}
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="nombreTarjeta">{t("CARDHOLDER_NAME")}</label>
                                            <input 
                                                type="text" 
                                                className="form-control" 
                                                id="nombreTarjeta" 
                                                value={nombreTarjeta} 
                                                onChange={(e) => setNombreTarjeta(e.target.value)} 
                                                onBlur={checkInput.nombreTarjeta}
                                                placeholder={t("CARDHOLDER_NAME")}
                                                style={{ borderColor: nombreTarjetaError ? 'red' : '' }}
                                                disabled={saving}
                                            />
                                            {nombreTarjetaError && <span className="text-danger">{nombreTarjetaError}</span>}
                                        </div>
                                    </Fragment>
                                )
                            }
                        </SimpleGrid>
                        <div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
                            <Button
                                colorScheme="teal"
                                onClick={requestUpdateTitular}
                                mt={4}
                                type="submit"
                                isLoading={saving}
                                loadingText={t("SAVING")}
                                isDisabled={saving}
                                disabled={saving}
                            >
                                Guardar
                            </Button>
                            <Button
                                colorScheme="red"
                                onClick={() => setConfirmModal({
                                    confirmTitle: t("DELETE_HOLDER"),
                                    confirmTitle: t("DELETE_HOLDER_CONFIRM"),
                                    idToDelete: titularId,
                                    confirmIsOpen: true,
                                })}
                                mt={4}
                                ml={3}
                                isLoading={deleting}
                                loadingText={t("DELETING")}
                                isDisabled={deleting}
                                disabled={deleting}
                            >
                                {t("DELETE")}
                            </Button>
                        </div>
                        <InfoModal
                            title={infoTitle}
                            message={infoMessage}
                            isOpen={infoIsOpen}
                            onClose={() => setInfoModal(modalInfoDefault)}
                            isError={infoIsError}
                            callback={infoCallback}
                        />
                        <ConfirmModal
                            title={confirmTitle}
                            message={confirmMessage}
                            isOpen={confirmIsOpen}
                            onClose={() => setConfirmModal(modalConfirmDefault)}
                            onConfirm={requestDeleteTitular}
                            isLoading={deleting}
                        />
                    </div>
                )
            }
        </div>
    )
}

export default NuevoEditarTitular;